import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../../components/layout/header/Header';
import { usePopup } from '../../../components/common/Popup';
import PaginaRelatorio from '../../../components/features/relatorioConcessao/PaginaRelatorio';
import RelatorioConcessaoContent from '../../../components/features/relatorioConcessao/RelatorioConcessaoContent';
import { RELATORIOS_CONCESSAO } from '../../../components/features/relatorioConcessao/constantes';
import { BotaoPdf, Mensagem } from '../../../components/features/relatorioConcessao/estilos';
import { useFiltrosRelatorio } from '../../../components/features/relatorioConcessao/useFiltrosRelatorio';
import apiService from '../../../services/api';
import statistics from '../../../assets/statistics.png';

const ESPERA_DA_BUSCA_MS = 300;

const RelatorioConcessao = () => {
  const { relatorio } = useParams();
  const definicao = RELATORIOS_CONCESSAO[relatorio];
  const popup = usePopup();
  const { filtros, atualizar } = useFiltrosRelatorio();
  const [painelAberto, setPainelAberto] = useState(null);
  const [busca, setBusca] = useState(filtros.q);
  const [gerandoPdf, setGerandoPdf] = useState(false);

  useEffect(() => {
    const espera = setTimeout(() => {
      if (busca !== filtros.q) atualizar({ q: busca });
    }, ESPERA_DA_BUSCA_MS);
    return () => clearTimeout(espera);
  }, [busca, filtros.q, atualizar]);

  const alternarPainel = (painel) => setPainelAberto((atual) => (atual === painel ? null : painel));

  const gerarPdf = async () => {
    setGerandoPdf(true);
    try {
      await apiService.downloadRelatorioConcessaoPdf(relatorio, { ...filtros, q: busca });
    } catch (erro) {
      await popup.alert({ icon: 'warning', title: 'Não foi possível gerar o PDF', message: erro.message });
    } finally {
      setGerandoPdf(false);
    }
  };

  if (!definicao) {
    return (
      <PaginaRelatorio>
        <Mensagem>Relatório não encontrado.</Mensagem>
      </PaginaRelatorio>
    );
  }

  return (
    <PaginaRelatorio>
      <Header
        prefixText="RELATÓRIO DE CONCESSÃO"
        icon={statistics}
        title={definicao.titulo}
        filtrar
        onFiltrar={() => alternarPainel('filtros')}
        ordenar
        onOrdenar={() => alternarPainel('ordenacao')}
        search
        searchValue={busca}
        searchPlaceholder="Pesquisar por palavra-chave"
        onSearchChange={setBusca}
        acoes={
          <BotaoPdf type="button" onClick={gerarPdf} disabled={gerandoPdf}>
            {gerandoPdf ? 'Gerando...' : 'Gerar pdf'}
            <span className="material-symbols-outlined">picture_as_pdf</span>
          </BotaoPdf>
        }
      />
      <RelatorioConcessaoContent
        relatorio={relatorio}
        painelAberto={painelAberto}
        filtros={filtros}
        atualizar={atualizar}
      />
    </PaginaRelatorio>
  );
};

export default RelatorioConcessao;
